import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonagpurcab() {



  const cardData = {
"keyword": "Pune to Nagpur Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Nagpur Cab service for long-distance travel, business trips, family visits, and outstation journeys. With experienced drivers, well-maintained air-conditioned vehicles, and transparent pricing with no hidden charges, we ensure a safe, smooth, and stress-free travel experience. Our Pune to Nagpur taxi service is designed for punctual pickups, flexible one-way and round-trip options, and complete travel convenience. Choose from sedans, SUVs, and premium cars suitable for solo travelers, families, and corporate clients. With 24/7 customer support and easy booking options, Shivai Travels provides a dependable intercity travel solution between Pune and Nagpur.",

"topPlaces": [
  {
    "title": "Deekshabhoomi",
    "description":
      "Deekshabhoomi is a famous Buddhist monument in Nagpur and an important pilgrimage site. Travelers using Pune to Nagpur cab service often visit this peaceful and historically significant landmark."
  },
  {
    "title": "Futala Lake",
    "description":
      "Futala Lake is a popular scenic spot in Nagpur known for its beautiful sunset views and musical fountains. A cab journey from Pune makes it easy to enjoy this relaxing lakeside attraction."
  },
  {
    "title": "Ambazari Lake",
    "description":
      "Ambazari Lake is one of the largest lakes in Nagpur surrounded by gardens and walking tracks. Pune to Nagpur cab travelers often visit this peaceful destination for relaxation and sightseeing."
  },
  {
    "title": "Sitabuldi Fort",
    "description":
      "Sitabuldi Fort is a historic landmark located in the heart of Nagpur offering panoramic city views. Cab services from Pune provide convenient access to this heritage site."
  },
  {
    "title": "Maharaj Bagh Zoo",
    "description":
      "Maharaj Bagh Zoo is a popular family attraction in Nagpur featuring various animal species and greenery. Pune to Nagpur taxi service ensures a comfortable journey for family outings."
  },
  {
    "title": "Ramtek Temple",
    "description":
      "Ramtek Temple is a famous Hindu pilgrimage site located near Nagpur associated with Lord Rama. Travelers from Pune often visit this spiritual destination via cab service."
  },
  {
    "title": "Zero Mile Stone",
    "description":
      "Zero Mile Stone marks the geographical center of colonial India and is a unique historical monument in Nagpur. Cab travelers from Pune often include this landmark in their sightseeing plans."
  },
  {
    "title": "Swaminarayan Temple Nagpur",
    "description":
      "Swaminarayan Temple is a beautiful and peaceful religious site in Nagpur known for its architecture and spiritual atmosphere. Pune to Nagpur cab service offers easy access for devotees."
  },
  {
    "title": "Dragon Palace Temple",
    "description":
      "Dragon Palace Temple is a serene Buddhist temple located near Nagpur known for its architecture and peaceful environment. Travelers from Pune often visit this attraction for spiritual tourism."
  },
  {
    "title": "Kasturchand Park",
    "description":
      "Kasturchand Park is a large public ground in Nagpur used for events, exhibitions, and gatherings. Cab service from Pune ensures easy access to this central city attraction."
  }
],



services: [
  {
    name: "Pune to Nagpur Cab",
    description: "Pune to Nagpur cab service provides reliable long-distance transportation between Pune and Nagpur with comfortable vehicles and experienced drivers. Vehicles are suitable for highway travel ensuring smooth and safe journeys for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nagpur. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Nagpur Taxi",
    description: "Pune to Nagpur taxi service offers dependable transportation for passengers traveling between Pune and Nagpur with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Nagpur. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Nagpur",
    description: "Cab from Pune to Nagpur service provides comfortable intercity transportation for passengers traveling for business, tourism, and family visits. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Nagpur. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Nagpur",
    description: "Taxi from Pune to Nagpur service offers reliable transportation with comfortable vehicles and professional drivers for long-distance travel between Pune and Nagpur. Vehicles provide smooth highway travel suitable for tourism, business meetings, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Nagpur. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Nagpur Cab Service",
    description: "Pune to Nagpur cab service provides dependable transportation solutions for passengers traveling between Pune and Nagpur with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for highway travel ensuring safe and smooth journeys for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nagpur. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Nagpur Taxi Fare",
    description: "Pune to Nagpur taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Nagpur. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nagpur. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Nagpur One Way Cab",
    description: "Pune to Nagpur one way cab service provides economical transportation for passengers traveling from Pune to Nagpur without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Nagpur including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Nagpur Round Trip Taxi",
    description: "Pune to Nagpur round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Nagpur. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nagpur. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Nagpur Cab Booking",
    description: "Pune to Nagpur cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Nagpur. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nagpur. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Nagpur Cab",
    description: "Cheap Pune to Nagpur cab service provides affordable transportation between Pune and Nagpur with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for tourism, business travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Nagpur. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Nagpur Taxi",
    description: "Best Pune to Nagpur taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nagpur. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Nagpur Cab",
    description: "Sedan Pune to Nagpur cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Nagpur. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Nagpur. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Nagpur Taxi",
    description: "SUV Pune to Nagpur taxi service provides spacious transportation for families and groups traveling between Pune and Nagpur. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Nagpur. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Nagpur Cab",
    description: "Innova Pune to Nagpur cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Nagpur. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Long Distance Cab Pune Nagpur",
    description: "Long distance cab Pune Nagpur service offers dependable highway transportation for passengers traveling between Pune and Nagpur with comfortable vehicles and experienced chauffeurs. Vehicles provide smooth ride quality and spacious seating suitable for extended travel journeys. Professional drivers ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Nagpur. Flexible booking options allow convenient long-distance cab reservations."
  },
  {
    name: "Pune to Amravati Cab Service",
    description: "Pune to Amravati cab service provides reliable transportation between Pune and Amravati with comfortable vehicles and professional drivers. Vehicles ensure smooth highway travel suitable for business trips, family journeys, tourism, and long-distance travel requirements. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Amravati. Vehicles include sedans, SUVs, Innova Crysta, and tempo travellers suitable for different travel needs. Flexible booking options allow convenient one-way and round-trip cab reservations."
  }
],

tableData: [
  ["Pune to Nagpur Cab", "Pune to Nagpur Taxi"],
  ["Cab from Pune to Nagpur", "Taxi from Pune to Nagpur"],
  ["Pune to Nagpur Cab Service", "Pune to Nagpur Taxi Fare"],
  ["Pune to Nagpur One Way Cab", "Pune to Nagpur Round Trip Taxi"],
  ["Pune to Nagpur Cab Booking", "Cheap Pune to Nagpur Cab"],
  ["Best Pune to Nagpur Taxi", "Sedan Pune to Nagpur Cab"],
  ["SUV Pune to Nagpur Taxi", "Innova Pune to Nagpur Cab"],
  ["Long Distance Cab Pune Nagpur", "Pune to Amravati Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Nagpur Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Nagpur cab service with professional drivers, comfortable vehicles, and punctual pickup for safe and smooth long-distance travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Nagpur Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Nagpur cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Nagpur Cab Service Availability",
        WhyChoosedescription: "Our Pune to Nagpur cab service operates 24 hours a day for business travel, family trips, corporate transportation, emergency travel, and airport transfers."
      },
      {
        WhyChooseheading: "Comfortable & Sanitized AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Nagpur taxi service, round-trip bookings, multi-day travel plans, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Options",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, business travelers, and groups."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Nagpur highway routes and ensure safe driving, smooth travel, and timely arrival for every intercity journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Nagpur cab service?", answer: "Pune to Nagpur cab service provides comfortable taxi transportation between Pune and Nagpur for business travel, family trips, and long-distance journeys." },
    { question: "Is Pune to Nagpur cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Nagpur cab service." },
    { question: "Which vehicles are available for Pune to Nagpur travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Nagpur?", answer: "Yes, customers can book one-way as well as round-trip Pune to Nagpur taxi services." },
    { question: "Do you provide airport pickup and drop service?", answer: "Yes, Shivai Travels provides airport transfer services along with outstation cab bookings." },
    { question: "Are all Pune to Nagpur taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Nagpur cab service online?", answer: "Yes, customers can easily book Pune to Nagpur cab service online or through phone booking." },
    { question: "Do you provide cabs for family and corporate travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and corporate travel." },
    { question: "Are Pune to Nagpur cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Nagpur cab service?", answer: "Yes, advance booking is available and recommended for long-distance travel and holiday seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Shrikant Patil",
    feedback:
      "Shivai Travels provided a very comfortable Pune to Nagpur cab service with a well-maintained vehicle and a skilled driver who ensured a smooth long-distance highway journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Pune to Nagpur taxi service was excellent with on-time pickup, safe driving, and a relaxing travel experience throughout the long trip.",
    rating: 5
  }
];






































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nagpur Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-nagpur-cab.jpg",
  "description": "Book Pune to Nagpur cab service for safe and comfortable long-distance travel. Shivai Travels offers affordable one-way and round-trip taxi service with sedan, SUV, Innova, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-nagpur-cab"
  }
};






  return (
    <div>

<Helmet>
  <title>Pune to Nagpur Cab | Affordable Long Distance Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Nagpur cab service for one-way and round trip travel. Affordable long-distance taxi options with sedan, SUV, Innova, and luxury cabs available 24x7 for safe journeys."
  />

  <meta
    name="keywords"
    content="Pune to nagpur cab, pune to nagpur taxi, cab from pune to nagpur, taxi from pune to nagpur, pune to nagpur cab service, pune to nagpur taxi fare, pune to nagpur one way cab, pune to nagpur round trip taxi, pune to nagpur cab booking, cheap pune to nagpur cab, best pune to nagpur taxi, sedan pune to nagpur cab, suv pune to nagpur taxi, innova pune to nagpur cab, long distance cab pune nagpur, Pune to Nagpur Cab Service, Pune to Nagpur Taxi Service, Pune to Nagpur Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonagpurcab;